import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { WarningIcon } from "@phosphor-icons/react";
import { useTranslations } from "use-intl";

interface Props {
  open: boolean;
  price: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const PriceChangedModal = ({
  open,
  price,
  onConfirm,
  onCancel,
}: Props) => {
  const t = useTranslations();

  return (
    <Dialog open={open}>
      <DialogContent className="flex flex-col items-center gap-1">
        <WarningIcon
          size={60}
          color="var(--color-semantic-error-strong)"
          className="mb-3"
        />
        <div className="text-center text-heading-h3 text-text-primary">
          {t("priceChange.title")}
        </div>
        <div className="text-center text-sm text-text-primary">
          {t("priceChange.content")}
        </div>

        <div className="mt-1 text-center text-heading-h4 text-text-primary">
          {price}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="mt-4 flex w-full flex-col gap-2">
          <Button variant="contained" fullWidth onClick={onConfirm}>
            {t("priceChange.confirmButton")}
          </Button>
          <Button variant="outlined" fullWidth onClick={onCancel}>
            {t("priceChange.cancelButton")}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};
